import { TOE_ADMINS_GROUP } from '../constants';
import { useAuth } from './useAuth';
export function useHasUserManagementPermission() {
    let hasPermission = false;
    const { user } = useAuth();
    if (user) {
        hasPermission =
            user.email.endsWith('@conxai.com') || (user.groups || []).includes(TOE_ADMINS_GROUP);
    }
    return hasPermission;
}
